import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "billetagePaiementModal",
  tabindex: "-1",
  "aria-labelledby": "billetagePaiementModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 mb-3" }
const _hoisted_7 = { class: "billetage-card billetage-encaissement" }
const _hoisted_8 = { class: "billetage-card-header" }
const _hoisted_9 = { class: "billetage-card-amount" }
const _hoisted_10 = { class: "billetage-card-body" }
const _hoisted_11 = { class: "billetage-col" }
const _hoisted_12 = ["onUpdate:modelValue", "onClick"]
const _hoisted_13 = { class: "billetage-col" }
const _hoisted_14 = ["onUpdate:modelValue", "onInput"]
const _hoisted_15 = { class: "billetage-col" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "col-md-6 mb-3" }
const _hoisted_18 = { class: "billetage-card billetage-sortie" }
const _hoisted_19 = { class: "billetage-card-header" }
const _hoisted_20 = { class: "billetage-card-amount" }
const _hoisted_21 = { class: "billetage-card-body" }
const _hoisted_22 = { class: "billetage-col" }
const _hoisted_23 = ["onUpdate:modelValue", "onClick"]
const _hoisted_24 = { class: "billetage-col" }
const _hoisted_25 = ["onUpdate:modelValue", "onInput"]
const _hoisted_26 = { class: "billetage-col" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = {
  key: 0,
  class: "alert alert-danger mt-3 py-2 mb-0"
}
const _hoisted_29 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_30 = {
  key: 1,
  class: "alert alert-warning mt-2"
}
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h5", { class: "modal-title text-black" }, [
            _createElementVNode("i", { class: "fa fa-calculator me-2" }),
            _createTextVNode("Billetage de Vente ")
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "billetage-card-title" }, "Billetage Encaissement", -1)),
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.montantTotalEncaissement || 0) + " Fcfa", 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"billetage-table-header\" data-v-26eca3c8><div class=\"col-header\" data-v-26eca3c8>Monnaie</div><div class=\"col-header\" data-v-26eca3c8>Quantité</div><div class=\"col-header\" data-v-26eca3c8>Montant</div></div><hr class=\"my-2\" data-v-26eca3c8>", 2)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'enc-' + index,
                      class: "billetage-row"
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                          readonly: "",
                          class: "form-control form-control-sm billetage-monnaie encaissement",
                          onClick: ($event: any) => (_ctx.incrementBilletage(billetage, 'encaissement')),
                          title: "Cliquer pour incrémenter"
                        }, null, 8, _hoisted_12), [
                          [_vModelText, billetage.libelle]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "0",
                          "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                          onInput: ($event: any) => (_ctx.handleBilletageInput($event, billetage, 'encaissement')),
                          onKeypress: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restrictInput($event))),
                          class: "form-control form-control-sm",
                          placeholder: "0"
                        }, null, 40, _hoisted_14), [
                          [
                            _vModelText,
                            billetage.qteBillet,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                          readonly: "",
                          class: "form-control form-control-sm"
                        }, null, 8, _hoisted_16), [
                          [_vModelText, billetage.montant]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "billetage-card-title" }, "Reliquat à Rendre", -1)),
                  _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.reliquatCalcule || 0) + " Fcfa", 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"billetage-table-header\" data-v-26eca3c8><div class=\"col-header\" data-v-26eca3c8>Monnaie</div><div class=\"col-header\" data-v-26eca3c8>Quantité</div><div class=\"col-header\" data-v-26eca3c8>Montant</div></div><hr class=\"my-2\" data-v-26eca3c8>", 2)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'sort-' + index,
                      class: "billetage-row"
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                          readonly: "",
                          class: "form-control form-control-sm billetage-monnaie sortie",
                          onClick: ($event: any) => (_ctx.incrementBilletage(billetage, 'sortie')),
                          title: "Cliquer pour incrémenter"
                        }, null, 8, _hoisted_23), [
                          [_vModelText, billetage.libelle]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "0",
                          "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                          onInput: ($event: any) => (_ctx.handleBilletageInput($event, billetage, 'sortie')),
                          onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.restrictInput($event))),
                          class: "form-control form-control-sm",
                          placeholder: "0"
                        }, null, 40, _hoisted_25), [
                          [
                            _vModelText,
                            billetage.qteBillet,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                          readonly: "",
                          class: "form-control form-control-sm"
                        }, null, 8, _hoisted_27), [
                          [_vModelText, billetage.montant]
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.montantTotalSortie > _ctx.reliquatCalcule)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                        _createElementVNode("small", null, "Le billetage de sortie (" + _toDisplayString(_ctx.montantTotalSortie) + " Fcfa) dépasse le reliquat (" + _toDisplayString(_ctx.reliquatCalcule) + " Fcfa).", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (_ctx.billetageError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.billetageError), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.reliquatNonRendu > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                _createTextVNode(" Reliquat non rendu au client: " + _toDisplayString(_ctx.reliquatNonRendu) + " Fcfa ", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.valider && _ctx.valider(...args))),
            "data-bs-dismiss": "modal",
            disabled: _ctx.montantTotalEncaissement < _ctx.totalttc || _ctx.montantTotalSortie > _ctx.reliquatCalcule
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fa fa-check me-2" }, null, -1),
            _createTextVNode("Valider ")
          ]), 8, _hoisted_32),
          _cache[11] || (_cache[11] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("i", { class: "fa fa-times me-2" }),
            _createTextVNode("Annuler ")
          ], -1))
        ])
      ])
    ])
  ]))
}